import { Accordion, Button, Grid, Icon } from "semantic-ui-react";
import { handleFormChange } from "../../../Helpers";
import { getIsWhiteLabeled } from "../../../helpers/PermissionHelper";
import { ILoanDetailSectionInput } from "../../interfaces/Loan";
import BCEmptyState from "../../ui/BCEmptyState";
import BCFormInput from "../../ui/BCFormInput";
import BPLoanDetailSectionContent from "./BPLoanDetailSectionContent";

interface ILoanDetailSectionProps {
  title: string;
  titleEllipsisItems?: any[];
  accordionId: string;
  isGreaterThanMobile: boolean;
  activeAccordions: string[];
  applicationInfo?: any;
  applicationMetadata?: any;
  pricingInfo?: any;
  handleActiveAccordions: (accordionId: string) => void;
  displayObj?: any;
  mainPatchObj: any;
  setMainPatchObj: (value: any) => any;
  mainPatchArr: any;
  setMainPatchArr: (value: any) => any;
  subPatchObjName?: any;
  subPatchObj: any;
  setSubPatchObj: (value: any) => any;
  isEditMode: boolean;
  handleFormChange: (value: string, field: string, obj: any, setObj: (value: any) => any, type: string, handleCustomFormChange?: any, charLimit?: number, index?: number) => void;
  index?: number;
  handleEditApplication: any;
  inputs?: ILoanDetailSectionInput[];
  table?: any;
  brokerButtonOverrideCSS: any;
  handleAdd?: any;
  dropdown?: any;
  permissions?: any[];
  isLoanApplication?: boolean;
  borrowerApplicationInfo?: any;
  specialState?: any;
  customStateAction?: any;
  customStateActionButton?: any;
  invalidProps?: any;
  validationGroupName?: any;
  inputSections?: [
    {
      sectionTitle?: string;
      inputs?: ILoanDetailSectionInput[];
    }
  ]
  titleError?: boolean;
}

const BPLoanDetailSection = ({ ...props }: ILoanDetailSectionProps) => {
  const handleLoanDetailSectionEmpty = (inputs) => {
    let isSectionValid = false;
    if (((props.applicationInfo && props.applicationMetadata) || props.pricingInfo) && inputs && inputs.length > 0) {
      inputs.forEach(input => {
        if (input.value !== null && input.value !== undefined) {
          isSectionValid = true;
        }
      });
    }

    return isSectionValid;
  };

  const isInputsValid = handleLoanDetailSectionEmpty(props.inputs);
  return (
    <Accordion className="accordion-details-title">
      <Accordion.Title
        className="summary-accordion-title"
        active={props.activeAccordions.includes(props.accordionId)}
        index={props.accordionId}
        onClick={() => props.handleActiveAccordions(props.accordionId)}
      >
        <BCFormInput
          labelClass={`secondary-title-label form-input-header-secondary form-input-border-secondary cursor-pointer ${props.titleError ? "interior-card-accordion-title-red" : ""}`}
          label={props.title}
          labelIcon={<Icon name='dropdown' />}
          rightLabelElement={props.titleEllipsisItems}
        />
      </Accordion.Title>
      <Accordion.Content active={props.activeAccordions.includes(props.accordionId)}>
        {props.inputSections?.map((section, i) => 
          <div className="summary-subaccordion" key={`loan-input-section-${i}`}>
            {section.sectionTitle && <div className="summary-subaccordion-title">
              <label key={`sub-accordion-${i}`}>{section.sectionTitle}</label>
            </div>}
            {section.inputs && <BPLoanDetailSectionContent
              isGreaterThanMobile={props.isGreaterThanMobile}
              inputs={section.inputs}
              displayObj={props.displayObj}
              mainPatchObj={props.mainPatchObj}
              setMainPatchObj={props.setMainPatchObj}
              mainPatchArr={props.mainPatchArr}
              setMainPatchArr={props.setMainPatchArr}
              subPatchObjName={props.subPatchObjName}
              subPatchObj={props.subPatchObj}
              setSubPatchObj={props.setSubPatchObj}
              isEditMode={props.isEditMode}
              handleFormChange={handleFormChange}
              isLoanApplication={props.isLoanApplication}
              borrowerApplicationInfo={props.borrowerApplicationInfo}
              index={props.index}
              invalidProps={props.invalidProps}
              validationGroupName={props.validationGroupName}
            />}
          </div>)
        }
        {isInputsValid && <BPLoanDetailSectionContent
          isGreaterThanMobile={props.isGreaterThanMobile}
          inputs={props.inputs}
          mainPatchObj={props.mainPatchObj}
          setMainPatchObj={props.setMainPatchObj}
          mainPatchArr={props.mainPatchArr}
          setMainPatchArr={props.setMainPatchArr}
          subPatchObjName={props.subPatchObjName}
          subPatchObj={props.subPatchObj}
          setSubPatchObj={props.setSubPatchObj}
          isEditMode={props.isEditMode}
          handleFormChange={handleFormChange}
          isLoanApplication={props.isLoanApplication}
          borrowerApplicationInfo={props.borrowerApplicationInfo}
          index={props.index}
          invalidProps={props.invalidProps}
          validationGroupName={props.validationGroupName}
        />}
        {props.table}
        {(!isInputsValid && !props.table) && <Grid>
          <Grid.Row className="details-row">
            <Grid.Column width={16}>
              {props.specialState 
                ? <BCEmptyState
                  emptyStateClass="application-details-empty-state"
                  icon="user"
                  text={props.specialState}
                  button={props.customStateAction && props.isEditMode ? <Button
                    className="bp-button details-button"
                    icon
                    onClick={() => props.customStateAction()}
                  >{props.customStateActionButton}</Button> : null}
                />
                : <BCEmptyState
                  emptyStateClass="application-details-empty-state"
                  icon="pencil"
                  text={`Looks like you have no ${props.title.toLocaleLowerCase()} data.`}
                  button={props.isEditMode && props.handleAdd ? <Button
                    className={getIsWhiteLabeled() ? `details-button ${props.brokerButtonOverrideCSS}` : "bp-button details-button"}
                    icon
                    onClick={() => props.handleAdd()}
                  >Add {props.title}</Button> : null}
                />
              }
            </Grid.Column>
          </Grid.Row>
        </Grid>}
      </Accordion.Content>
    </Accordion>
  );
};

export default BPLoanDetailSection;